import { NamedRouteConfig } from './types';
import { Route } from 'vue-router';
import { IssueExternalResolverPage } from '@/ui/pages/issue/public/IssueExternalResolverPage';
import { parseInt10 } from '@/ui/helpers';
import { UpdateApp } from '@/ui/pages/UpdateApp';
import { HASH_KEY } from '@/services/token';

const parseHash = (route: Route) => ({ hash: route.params.hash });
const parseId = (route: Route) => ({ id: parseInt10(route.params.id) });

const issueExternalResolverProps = (route: Route) => {
  return { ...parseHash(route), ...parseId(route) };
};

export const guestLogoLayoutRoutes: NamedRouteConfig[] = [
  {
    path: '/public/:hash/issues/:id',
    name: 'issueExternalResolver',
    component: IssueExternalResolverPage,
    props: issueExternalResolverProps,
    meta: {
      classes: 'logo-layout--narrow-header',
    },
    beforeEnter: (to, from, next) => {
      sessionStorage.setItem(HASH_KEY, to.params.hash);
      next();
    },
  },
  {
    path: '/update-app',
    name: 'updateApp',
    component: UpdateApp,
  },
];
